import { distance } from "@turf/turf"
import { point } from "@turf/turf"

export const computeDistanceKm = (from: [number, number], to: [number, number]): number => {
  return distance(point(from), point(to), { units: "kilometers" })
}

export const formatDistanceLabel = (distanceKm: number): string => {
  if (distanceKm < 1) {
    return `a ${Math.round(distanceKm * 1000)} m d'ici`
  }
  return `a ${distanceKm.toFixed(1)} km d'ici`
}
